import React from 'react';
import Screen from './Screen';
import TopBarEvent from '../elements/TopBar/TopBarEvent';
import Blocklink from '../elements/Blocklink/Blocklink';
import Input from '../elements/forms/Input';
import {dialogAlert} from '../elements/Dialog/dialogs';

export default class PokeParticipantScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            busy: false,
            message: '',
        };
    }
    componentDidMount() {
        this.state.mounted = true;
    }
    componentWillUnmount() {
        this.state.mounted = false;
    }
    render() {
        let {event, user, i18n} = this.props,
            header = (
                <div>
                    <TopBarEvent event={event} onReturnClick={this.props.onClose}>
                        {i18n['label.message']}
                    </TopBarEvent>
                </div>
            );

        return (
            <Screen header={header}>
                <form onSubmit={this.handleSubmit.bind(this)}>
                    <div className="content">
                        <Input
                            type="textarea"
                            rows="5"
                            label={i18n['label.message']}
                            value={this.state.message}
                            onChange={this.handleChange.bind(this, 'message')}
                        />
                    </div>
                    <br />
                    <Blocklink
                        type="submit"
                        customColor={event.settings.primary_color}
                        style={{
                            textAlign: 'right',
                        }}
                        next="next">
                        {i18n['label.send']}
                    </Blocklink>
                </form>
            </Screen>
        );
    }
    handleChange(field, value) {
        this.setState({[field]: value});
    }
    async handleSubmit(e) {
        e.preventDefault();

        let message = this.state.message;
        if (message) {
            this.setState({busy: true});
            app.api.events
                .poke(this.props.event.id, this.props.user.participant_id, message)
                .then(async data => {
                    if (data.sent == 'yes') {
                        await dialogAlert(this.props.i18n['label.successfully.sent']);
                        if (this.props.onClose) {
                            this.props.onClose();
                        }
                    } else {
                        await dialogAlert(this.props.i18n['label.message.not.send']);
                    }
                })
                .catch(err => {
                    console.error(err);
                })
                .then(() => {
                    if (this.state.mounted) {
                        this.setState({busy: false});
                    }
                });
        } else {
            await dialogAlert(this.props.i18n["label.message.field.can't.be.empty"]);
        }
    }
}
